import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import LandingPage from "@/pages/LandingPage";
import PublicPricing from "@/pages/PublicPricing";
import Trust from "@/pages/Trust";
import TermsOfService from "@/pages/legal/TermsOfService";
import PrivacyPolicy from "@/pages/legal/PrivacyPolicy";
import RefundPolicy from "@/pages/legal/RefundPolicy";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import MagicLink from "@/pages/MagicLink";
import AuthCallback from "@/pages/AuthCallback";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppShell from "@/components/AppShell";
import Dashboard from "@/pages/app/Dashboard";
import Documents from "@/pages/app/Documents";
import Scans from "@/pages/app/Scans";
import ScanDetail from "@/pages/app/ScanDetail";
import Monitoring from "@/pages/app/Monitoring";
import Reports from "@/pages/app/Reports";
import Settings from "@/pages/app/Settings";
import Notifications from "@/pages/app/Notifications";
import Billing from "@/pages/app/Billing";
import AdminLeads from "@/pages/app/AdminLeads";
import AdminAnalytics from "@/pages/app/AdminAnalytics";
import Templates from "@/pages/app/Templates";
import Compare from "@/pages/app/Compare";
import Recipients from "@/pages/app/Recipients";
import PublicScorecard from "@/pages/PublicScorecard";
import { Toaster } from "@/components/ui/sonner";

function HashSessionGuard({ children }) {
  // Process Google OAuth callback no matter which route the user lands on.
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <HashSessionGuard>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/pricing" element={<PublicPricing />} />
              <Route path="/trust" element={<Trust />} />
              <Route path="/terms" element={<TermsOfService />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/refund" element={<RefundPolicy />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/magic-link" element={<MagicLink />} />
              <Route path="/auth/callback" element={<AuthCallback />} />
              <Route path="/scorecard/:token" element={<PublicScorecard />} />

              <Route
                element={
                  <ProtectedRoute>
                    <AppShell />
                  </ProtectedRoute>
                }
              >
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/documents" element={<Documents />} />
                <Route path="/scans" element={<Scans />} />
                <Route path="/scans/:id" element={<ScanDetail />} />
                <Route path="/compare" element={<Compare />} />
                <Route path="/templates" element={<Templates />} />
                <Route path="/monitoring" element={<Monitoring />} />
                <Route path="/reports" element={<Reports />} />
                <Route path="/recipients" element={<Recipients />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/settings/notifications" element={<Notifications />} />
                <Route path="/billing" element={<Billing />} />
                <Route path="/admin/leads" element={<AdminLeads />} />
                <Route path="/admin/analytics" element={<AdminAnalytics />} />
              </Route>

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </HashSessionGuard>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
